import {SeparatorsEnum} from '../../../helpers/analyticsExportHelpers';
import {AnyMetricKey, getMetricLabels} from '../../../helpers/metricLabels';
import {CustomTableColumn, TableData} from '../../reportElements/table/tableHelpers';

// Various helpers for exporting metrics from charts and tables.

// The types that analytics values can take
export type AnalyticsDataPointValueType = string | number | undefined;

/**
 * Takes table data and returns a string containing
 * the data formatted as a CSV
 *
 * @param separator the seperator to use for the csv
 * @param columns the columns for the table
 * @param data the table data
 * @returns a string that is the data as a csv
 */
export const tableDataToCsv = (
  separator: SeparatorsEnum,
  columns: CustomTableColumn<TableData>[],
  data: TableData[],
) => {
  const result = [];

  const computeQuoteValue = (value: AnalyticsDataPointValueType) => computeCsvQuote(value, separator);
  const header = columns.map((column) => `"${column.Header ?? column.label}"`);
  result.push(header.join(separator));

  const makeRow = (row: TableData) => {
    const rowResult: AnalyticsDataPointValueType[] = Object.values(row)
      .map((value) => value.value)
      .map(computeQuoteValue);

    return rowResult;
  };

  data.forEach((row) => result.push(makeRow(row).join(separator)));

  return result.join('\n');
};

// helper for escaping values with quotes for csv's
export const computeCsvQuote = (value: AnalyticsDataPointValueType, separator: SeparatorsEnum) => {
  if (typeof value === 'string' && (value.includes(' ') || value.includes(separator))) {
    return `"${value}"`;
  }

  return value;
};

export const makeExportTitle = (metric: AnyMetricKey): string | undefined =>
  getMetricLabels(metric).label?.toLowerCase().replace(/ /g, '-');
